import { formValueSelector } from 'redux-form';
import _ from 'lodash';

import { SCHOOL_SITE_ORDER_FORM_NAME } from 'Common/FormEnum';
import { SchoolSiteOrderFieldEnum as Fields } from 'Common/FieldEnum';

const root = state => _.get(state, 'SchoolSiteOrderState');

const getFormValue = formValueSelector(SCHOOL_SITE_ORDER_FORM_NAME);

export const getDeliverOnServingDate = state =>
  getFormValue(state, Fields.IsDeliverOnServingDate);

export const getStartDate = state => getFormValue(state, Fields.StartServingDT);

export const getEndDate = state => getFormValue(state, Fields.EndServingDT);

export const getError = state => _.get(root(state), 'error');

export const getSaveMessage = state => _.get(root(state), 'saveMessage', '');

export const getFetching = state => _.get(root(state), 'fetching', false);



// WEBPACK FOOTER //
// ./src/pages/schoolsiteorder/state/selectors.js